<div class="max-w-full mx-auto">

  <div class="p-6 bg-white shadow rounded-lg">
    <!-- mx-auto  w-3/4 shadow-lg p-5  -->
    <form class="space-y-6">

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Proveedor</mat-label>
          <mat-select [(ngModel)]="selectedProviderId" name="selectedProviderId">
            <mat-option *ngFor="let provider of providers" [value]="provider.id">{{ provider.name }}</mat-option>
          </mat-select>
        </mat-form-field>



        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Fecha de inicio</mat-label>
          <input matInput [matDatepicker]="startDatePicker" placeholder="Fecha de inicio"
            [(ngModel)]="dateRange.startDate" name="startDate">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Fecha de fin</mat-label>
          <input matInput [matDatepicker]="endDatePicker" placeholder="Fecha de fin" [(ngModel)]="dateRange.endDate"
            name="endDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="flex justify-center gap-2 col-span-3">
          <button mat-raised-button
            class="bg-orange-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-orange-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-opacity-50"
            (click)="handleGetProviderBillsByDates()">
            Consultar
          </button>
        </div>
      </div>
    </form>
  </div>
  <h2 class="text-3xl font-semibold text-center mt-20 mb-5 text-gray-800 uppercase">Datos de facturación de proveedor
  </h2>

  <div class="overflow-auto rounded-lg rounded-b-none shadow-lg">
    <table class="w-full leading-normal">
      <thead class="bg-orange-500 text-white">
        <tr>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Unidad de Gestión</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            ID del Concepto de Facturación</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Cantidad</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Fecha de Inicio</th>

          <th class="px-5 py-3 border-b-2 border-orange-600">
            Fecha de Fin</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            ID de Familia</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            CIF</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Nombre</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Código de Cliente</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            PO</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            CECO</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Delegación</th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr *ngFor="let bill of providerData; even as isEven"
          class="hover:bg-gray-200 transition duration-150 ease-in-out">
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.managementUnit }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.billingConceptId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.amount }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.startDate }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.endDate }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.familyId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.cif }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.name }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.clientCode }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.po }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.ceco }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ bill.delegation }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bg-white shadow-md rounded-lg rounded-b-none  mt-5 p-7" *ngIf="providerData.length === 0 && !isLoading">
    <h1 class="text-2xl font-bold text-center text-gray-600">
      No se encontraron datos.
    </h1>
  </div>

  <ng-container *ngIf="providers.length > 0">
    <div class="relative mb-5">
      <mat-paginator [length]="providers.length" hidePageSize="true" [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="handlePageEvent($event)">
      </mat-paginator>
    </div>
  </ng-container>

  <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <svg class="animate-spin h-5 w-5 text-orange-500 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none"
      viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
  </div>
</div>